var _path, _path2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKbDesignerIcoPositiveAddTetx(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black_bez_okraje",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.67,27.8l4.68-10.44c.25-.56.7-.9,1.33-.9h.11c.63,0,1.06.34,1.31.9l4.68,10.44c.09.16.13.32.13.47,0,.59-.45,1.06-1.04,1.06-.52,0-.88-.31-1.08-.77l-1.03-2.36h-6.12l-1.06,2.43c-.18.45-.56.7-1.03.7-.58,0-1.03-.45-1.03-1.03,0-.16.05-.32.14-.5ZM20.92,24.24l-2.21-5.1-2.21,5.1h4.43Z",
    fill: "#030303",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.86,26.5v-.04c0-2.05,1.6-3.06,3.92-3.06,1.06,0,1.82.16,2.56.4v-.23c0-1.35-.83-2.07-2.36-2.07-.83,0-1.51.14-2.11.38-.13.04-.23.05-.34.05-.5,0-.92-.4-.92-.9,0-.4.27-.74.59-.86.9-.34,1.82-.56,3.06-.56,1.42,0,2.49.38,3.15,1.06.7.68,1.03,1.69,1.03,2.93v4.68c0,.59-.47,1.04-1.06,1.04-.63,0-1.06-.43-1.06-.92v-.36c-.65.77-1.64,1.39-3.1,1.39-1.78,0-3.37-1.03-3.37-2.94ZM32.38,25.82v-.65c-.56-.22-1.3-.38-2.16-.38-1.4,0-2.23.59-2.23,1.58v.04c0,.92.81,1.44,1.85,1.44,1.44,0,2.54-.83,2.54-2.03Z",
    fill: "#030303",
    strokeWidth: 0
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 9.88,
    x2: 26.5,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.5,
    y1: 38.01,
    x2: 26.5,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 38.07,
    y1: 21.45,
    x2: 38.07,
    y2: 26.45,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 9.93,
    y1: 21.45,
    x2: 9.93,
    y2: 26.45,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 9.88,
    x2: 9.88,
    y2: 14.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 9.88,
    x2: 14.88,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 38.01,
    x2: 14.88,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 9.88,
    y1: 38.01,
    x2: 9.88,
    y2: 33.02,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 38.01,
    x2: 37.92,
    y2: 33.02,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 38.01,
    x2: 32.92,
    y2: 38.01,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 9.88,
    x2: 32.92,
    y2: 9.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 37.92,
    y1: 9.88,
    x2: 37.92,
    y2: 14.88,
    fill: "#fff",
    stroke: "#030303",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKbDesignerIcoPositiveAddTetx);
export default __webpack_public_path__ + "static/media/kb-designer-ico-positive-add-tetx.ede36a115f12c1e2f63c0fc35a8497e3.svg";
export { ForwardRef as ReactComponent };